import styled from 'styled-components';

export const StyledStudentPaymentsElement = styled.div`
    width: 100%;
    min-width: 700px;
    height: 100%;
    background: #fff;
    border: 4px solid ${({ hasDeclaredBorderColor }) => (hasDeclaredBorderColor ? hasDeclaredBorderColor : '#6786be')};
    display: flex;
    justify-content: space-between;
    border-radius: 25px;
    padding: 5px 0;
`;
